import { useSnapshot } from 'valtio'
import { dataState } from '../../store/dataState.ts'
import { controlState } from '../../store/controlState.ts'
import React from 'react'
import { editStyle, showStyle } from './helpers/safeZoneHelper.ts'
import { SafeZonePolygon } from './mapComponents/SafeZonePolygon.tsx'
import { safeZoneState, setSafeZonePolygons } from '../../store/safeZoneState.ts'

export const SafeZones = () => {
    const safeZones = (useSnapshot(dataState) as typeof dataState).safeZones
    const editingSafeZoneId = (useSnapshot(safeZoneState) as typeof safeZoneState).safeZoneBeingEdited
    const showSafeZones = useSnapshot(controlState).showSafeZones

    // Single effect: rebuild polygons whenever any input changes. No clear/setTimeout flicker.
    const polygons = React.useMemo(() => {
        if (!showSafeZones || !safeZones?.length) return []
        return safeZones.map(zone => {
            const style = zone._id === editingSafeZoneId ? editStyle : showStyle
            return <SafeZonePolygon key={zone._id} zone={zone} options={style}/>
        })
    }, [safeZones, showSafeZones, editingSafeZoneId])

    // Keep the store in sync for any consumers that read safeZonePolygons directly.
    React.useEffect(() => {
        setSafeZonePolygons(polygons)
    }, [polygons])

    return <>{polygons}</>
}
